import React from 'react';
import { motion } from 'framer-motion';
interface BonusProps {
  number: string;
  title: string;
  image: string;
  description: string;
  value: string;
}
export function BonusCard({
  number,
  title,
  image,
  description,
  value
}: BonusProps) {
  return <motion.div whileHover={{
    y: -5
  }} className="bg-white border border-violet-100 rounded-xl overflow-hidden flex flex-col shadow-sm" data-id="element-160">
      <div className="aspect-square overflow-hidden bg-violet-50" data-id="element-161">
        <img src={image} alt={title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-162" />
      </div>
      <div className="p-6 flex-grow flex flex-col" data-id="element-163">
        <span className="text-violet-600 font-black text-xs mb-2 uppercase tracking-widest" data-id="element-164">
          BONO {number}
        </span>
        <h3 className="text-xl font-bold text-violet-950 mb-3 leading-tight" data-id="element-165">
          {title}
        </h3>
        <p className="text-violet-800/70 text-sm mb-6 flex-grow" data-id="element-166">
          {description}
        </p>
        <div className="pt-4 border-t border-violet-50" data-id="element-167">
          <p className="text-violet-300 text-xs line-through" data-id="element-168">
            VALORADO EN {value}
          </p>
          <p className="text-violet-600 font-black text-lg" data-id="element-169">HOY GRATIS</p>
        </div>
      </div>
    </motion.div>;
}